module.exports = __webpack_public_path__ + "img/Facebook_hover.36e2bf75.svg";